// test
export const getCount = state => {
  return state.count;
};
export const vuexUserInfo = state => {
  return state.userInfo;
};
export const vuexLoginFlay = state => {
  return state.loginFlay;
};
export const vuexDictsOptions = state => {
  return state.dictsOptions;
};



// WEBPACK FOOTER //
// ./src/vuex/getters.js